import { render, staticRenderFns } from "./SingleCard.vue?vue&type=template&id=9a44c2be&scoped=true&"
import script from "./SingleCard.vue?vue&type=script&lang=ts&"
export * from "./SingleCard.vue?vue&type=script&lang=ts&"
import style0 from "./SingleCard.vue?vue&type=style&index=0&id=9a44c2be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a44c2be",
  null
  
)

export default component.exports